import { makeStyles } from '@material-ui/core/styles'
import { themeCommon } from '../../../../styles/theme'

const useStyles = makeStyles((theme) => ({
    root: {
        textTransform: 'capitalize',
    },
    buttonDefault: {
        fontFamily: themeCommon.RobotoRegular,
        background: themeCommon.bg_btn,
        color: '#FFFFFF',
        fontSize: themeCommon.fontSize18px,
        '&:hover, &:focus, &:active': {
            color: '#FFFFFF',
            background: themeCommon.bg_btn,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px
        },
    },
    buttonStatusDone: {
        background:'#4DD091',
        '&:hover, &:focus, &:active': {
            color: '#FFFFFF',
            background: '#4DD0912'
        }
    },
    buttonStatusPending:{
        background:'#ffa000',
        '&:hover, &:focus, &:active': {
            color: '#FFFFFF',
            background: '#ffa000'
        }
    },
    btnTakeAssessment: {
        width: '200px',
        height: '50px',
        borderRadius: '10px',
        [theme.breakpoints.down('sm')]: {
            width: '150px',
        },
        [theme.breakpoints.down('xs')]: {
            height: '40px',
            width: '130px',
        }
    },
    isDisabled: {

    },
    customButton: {
        borderRadius: '10px',
        padding: '8px 60px',

        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
            padding: '8px 60px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
            padding: '5px 50px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
            padding: '3px 37px',
        },
    },
    customButtonNext: {
        paddingLeft: '23px',
        paddingRight: '23px',
        borderRadius: '10px',
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
            paddingLeft: '23px',
            paddingRight: '23px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
            paddingLeft: '20px',
            paddingRight: '20px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
            paddingLeft: '20px',
            paddingRight: '20px',
        },
    },
    customButtonBack: {
        background: '#EAEAEA',
        paddingLeft: '23px',
        paddingRight: '23px',
        borderRadius: '10px',
        marginRight: '10px',
        color: '#B2B2B2',
        '&:hover': {
            background: '#EAEAEA',
            color: '#B2B2B2',
        },
        '&:focus': {
            background: '#EAEAEA',
            color: '#B2B2B2',
        },
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
            paddingLeft: '23px',
            paddingRight: '23px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
            paddingLeft: '20px',
            paddingRight: '20px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
            paddingLeft: '20px',
            paddingRight: '20px',
        },
    },
}), {
    name: 'ButtonsHeadContainer',
    index: 1,
})

export default useStyles